const doc = [({"daily":"Daily", "monthly":"Monthly", "custom":"Range"})];
module.exports = doc.length <= 1 ? doc[0] : doc;